import { useEffect, useState } from "react";

export const NewSlider = ({ chartChannel, dataArrLive, dateTimesLive, minVal, maxVal, bgColor, fontSize }) => {

    const [currentValue, setCurrentValue] = useState(0);
    useEffect(() => {
        const matchedDatasets =
            chartChannel?.length === 0
                ? null
                : dataArrLive?.find(
                    (dataset) => dataset.label === chartChannel[0]
                );

        const currentVal = matchedDatasets
            ? matchedDatasets?.data.slice(-1)
            : [50];

        setCurrentValue(currentVal[0]);
    }, [dateTimesLive, chartChannel?.[0], minVal, maxVal]);


    return (
        <>
            <div style={{ fontSize: fontSize ? fontSize + "px" : "14px" }}>{currentValue || 50}</div>
            <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <p style={{ margin: 0, whiteSpace: "nowrap", fontSize: fontSize ? Number(fontSize) / 2.5 + "px" : "14px" }}>{minVal || 0}</p>
                <input
                    type="range"
                    value={currentValue || 50}
                    min={minVal || 0}
                    max={maxVal || 100}
                    style={{ flex: 1, margin: "0 8px", accentColor: bgColor ? bgColor : null }}
                />
                <p style={{ margin: 0, whiteSpace: "nowrap", fontSize: fontSize ? Number(fontSize) / 2.5 + "px" : "14px" }} >{maxVal || 100}</p>
            </div>
        </>
    )


}

export const Slider = ({
    dateTimesLive,
    chartChannel,
    dataArrLive,
    minVal,
    maxVal,
    bgColor,
    fontSize
}) => {
    const [currentValue, setCurrentValue] = useState();

    useEffect(() => {
        const matchedDatasets =
            chartChannel?.length > 0
                ? chartChannel?.map((label) =>
                    dataArrLive?.find((dataset) => dataset.label === label)
                )
                : [];

        const currentVal =
            matchedDatasets.length > 0 ? matchedDatasets[0]?.data.slice(-1) : [1];
        if (currentVal) {
            setCurrentValue(currentVal[0]);
        }
    }, [dateTimesLive, chartChannel, minVal, maxVal]);


    return (
        <>
            <div style={{ fontSize: fontSize ? fontSize + "px" : "14px" }}>{currentValue || 50}</div>
            <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <p style={{ margin: 0, whiteSpace: "nowrap", fontSize: fontSize ? Number(fontSize) / 2.5 + "px" : "14px" }}>{minVal || 0}</p>
                <input
                    type="range"
                    value={currentValue || 50}
                    min={minVal || 0}
                    max={maxVal || 100}
                    style={{ flex: 1, margin: "0 8px", accentColor: bgColor ? bgColor : null, fontSize: fontSize ? Number(fontSize) : "14px" }}
                />
                <p style={{ margin: 0, whiteSpace: "nowrap", fontSize: fontSize ? Number(fontSize) / 2.5 + "px" : "14px" }}>{maxVal || 100}</p>
            </div>
        </>
    )


}